import fetchGraphQl from "./fetchGraphQl";
import { useQuery } from "react-query";

const fetchElectricityData =
  (userId: string, { startDate, endDate }: any) =>
  async () => {
    const { data = { electricity: [] }, error } = await fetchGraphQl(
      `
      query queryElectricityData {
        electricity: daily_electricity_view (
          where: {timestamp: {_gt: "${startDate.toISOString()}", _lt: "${endDate.toISOString()}"}},
          order_by: {timestamp: asc}
        ) {
          timestamp
          consumed_by_miners
          consumed_by_growers
          chp_production
          imported_from_grid
          sold_to_grid
          euros_consumed_by_miners
          euros_consumed_by_growers
          euros_imported_from_grid
          euros_sold_to_grid
          buy_price
          sell_price
          buy_revenue
        }
      }
    `,
      "queryElectricityData",
      userId
    ) ?? {};

    let total = {
      consumedByMiners: 0,
      consumedByGrowers: 0,
      producedByCHP: 0,
      eurosConsumedByMiners: 0,
      eurosConsumedByGrowers: 0,
      eurosImportedFromGrid: 0,
      eurosSoldToGrid: 0,
      importedFromGrid: 0,
      soldToGrid: 0,
      price: 0,
      timestamp: '',
      buyRevenue: 0
    };

    if (!error) {
      data.electricity.forEach((dataItem: any, index: number) => {
        total.consumedByMiners += dataItem.consumed_by_miners;
        total.consumedByGrowers += dataItem.consumed_by_growers;
        total.producedByCHP += dataItem.chp_production;
        total.eurosConsumedByMiners += dataItem.euros_consumed_by_miners;
        total.eurosConsumedByGrowers += dataItem.euros_consumed_by_growers;
        total.eurosImportedFromGrid += dataItem.euros_imported_from_grid;
        total.eurosSoldToGrid += dataItem.euros_sold_to_grid;
        total.importedFromGrid += dataItem.imported_from_grid;
        total.soldToGrid += dataItem.sold_to_grid;
        total.buyRevenue += dataItem.buy_revenue;
        total.price = dataItem.buy_price;
        total.timestamp = dataItem.timestamp;

        data.electricity[index].value = dataItem.euros_imported_from_grid;
      });
    }

    return { data: data.electricity, total };
  };

export const useElectricityData = (userId: string, dayRange: any, farmName: string) => {
  return useQuery(["electricity", dayRange, farmName], fetchElectricityData(userId, dayRange), {
    refetchOnWindowFocus: true,
  });
};
